function waitForElm(selector) {
  return new Promise((resolve) => {
    const widget = document.querySelector('.recharge-subscription-widget');
    if (widget.querySelector(selector)) {
      return resolve(widget.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (widget.querySelector(selector)) {
        observer.disconnect();
        resolve(widget.querySelector(selector));
      }
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElm('.rc-subscription-details').then((elm) => {
  elm.style.display = 'none';
});
